"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskBasedProperty = exports.Initialiser = exports.LoaderGuard = exports.AppContext = void 0;
const merlin_loader_1 = require("@travelnest/merlin.loader");
const React = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const TaskCompletenessContext_1 = require("./context/TaskCompletenessContext");
const ValidationContext_1 = require("./context/ValidationContext");
const useInitialDataLoad_1 = require("./hooks/useInitialDataLoad");
const tasks_1 = require("./tasks");
const sync_1 = __importDefault(require("./tasks/sync"));
const cross_task_sync_1 = __importDefault(require("./tasks/cross-task-sync"));
const styles_1 = __importDefault(require("./view/components/styles"));
const BasePage_1 = require("./view/pages/base/BasePage");
const PropertyDashboardPage_1 = __importDefault(require("./view/pages/dashboard/PropertyDashboardPage"));
const ErrorBoundary_1 = require("./view/components/error-boundary/ErrorBoundary");
const helpers_1 = require("./hooks/helpers");
const types_1 = require("./types");
const capability_1 = require("./util/capability");
const useAuthentication_1 = __importDefault(require("./hooks/useAuthentication"));
const RoutingContext_1 = require("./context/RoutingContext");
const react_1 = require("react");
const helpers_2 = require("./view/pages/dashboard/helpers");
const tracking_1 = require("./tracking");
const modeGuard_1 = require("./util/modeGuard");
exports.AppContext = React.createContext({});
const LoaderGuard = (props) => {
    if (props.loading) {
        return React.createElement(BasePage_1.BasePage, null,
            React.createElement("div", { "data-testid": "loader-guard", style: { height: '60px' } },
                React.createElement(merlin_loader_1.Loader, { loading: true })));
    }
    else {
        return React.createElement(React.Fragment, null, props.children);
    }
};
exports.LoaderGuard = LoaderGuard;
const Initialiser = (props) => {
    const loading = (0, useInitialDataLoad_1.useInitialDataLoad)();
    React.useEffect(() => {
        if (!loading) {
            props.onInit();
        }
    }, [loading]);
    return null;
};
exports.Initialiser = Initialiser;
const LocationSync = () => {
    const { pathname } = (0, react_router_dom_1.useLocation)();
    React.useEffect(() => {
        window.scroll({ top: 0 });
    }, [pathname]);
    return null;
};
const App = (props) => {
    const capabilities = capability_1.Capabilities[props.mode] || types_1.onboardCapabilities;
    const [validationState, validationDispatch] = React.useReducer(ValidationContext_1.validationReducer, (0, ValidationContext_1.initialValidationState)());
    const [taskCompletenessState, taskCompletenessDispatch] = React.useReducer(TaskCompletenessContext_1.taskCompletenessReducer, (0, TaskCompletenessContext_1.initialCompletenessState)(capabilities));
    const [initialising, setInitialising] = React.useState(true);
    const authentication = (0, useAuthentication_1.default)();
    const [effectiveCapabilities, setEffectiveCapabilities] = (0, react_1.useState)(capabilities);
    const { getState } = (0, react_redux_1.useStore)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const location = (0, react_router_dom_1.useLocation)();
    // Where the app is running in local development mode, Cognito is not initialised correctly.
    const appReady = !initialising && (process.env.LOCAL_DEV ? true : authentication !== null);
    return React.createElement(RoutingContext_1.RouterContext.Provider, { value: { baseUrl: props.baseURL || '' } },
        React.createElement(ErrorBoundary_1.ErrorBoundary, { recoveryUrl: props.baseURL || '/' },
            React.createElement(exports.AppContext.Provider, { value: {
                    capabilities: effectiveCapabilities,
                    authentication,
                    entityActions: props.actions,
                    customerId: props.customerId,
                    propertyId: props.propertyId,
                    photosTask: props.photosTask,
                    availabilityTask: props.availabilityTask,
                    registerActionListener: props.registerActionListener,
                    deregisterActionListener: props.deregisterActionListener,
                    appMode: props.mode
                } },
                React.createElement(ValidationContext_1.ValidationContext.Provider, { value: { state: validationState, dispatch: validationDispatch } },
                    React.createElement(TaskCompletenessContext_1.TaskCompletenessContext.Provider, { value: { state: taskCompletenessState, dispatch: taskCompletenessDispatch } },
                        React.createElement(styles_1.default, null),
                        React.createElement(exports.Initialiser, { onInit: () => {
                                const property = (0, helpers_1.hydratedPropertySelector)(getState(), props.propertyId);
                                const redirectToMode = (0, modeGuard_1.shouldRedirectToMode)(property, props.mode);
                                if (redirectToMode) {
                                    console.log(`Redirecting from ${props.mode} to ${redirectToMode}`);
                                    navigate((0, modeGuard_1.newModeUrlPath)(location.pathname, props.mode, redirectToMode), { replace: true });
                                }
                                if (property && (0, helpers_2.isScLinked)(property)) {
                                    setEffectiveCapabilities(capabilities | types_1.DashboardCapabilities.DisablePricing | types_1.DashboardCapabilities.DisableAvailability);
                                }
                                setInitialising(false);
                            } }),
                        React.createElement(tracking_1.TrackingEventSync, null),
                        React.createElement(sync_1.default, { syncFacts: (0, capability_1.hasCapability)(capabilities, types_1.DashboardCapabilities.RecordTaskCompletionFacts) }),
                        React.createElement(LocationSync, null),
                        React.createElement(cross_task_sync_1.default, { propertyId: props.propertyId }),
                        React.createElement(react_router_dom_1.Routes, null,
                            Object.keys(tasks_1.TaskDetails).map((k) => {
                                const taskDetail = tasks_1.TaskDetails[k];
                                const path = `${(0, tasks_1.taskURL)(taskDetail)}${taskDetail.hasSubRoutes ? '/*' : ''}`;
                                return React.createElement(react_router_dom_1.Route, { key: taskDetail.routeName, path: path, element: React.createElement(exports.LoaderGuard, { loading: !appReady },
                                        React.createElement(taskDetail.component, { propertyId: props.propertyId, customerId: props.customerId })) });
                            }),
                            React.createElement(react_router_dom_1.Route, { path: '/', element: React.createElement(exports.LoaderGuard, { loading: !appReady },
                                    React.createElement(PropertyDashboardPage_1.default, { propertyId: props.propertyId, customerId: props.customerId, mode: props.mode })) })))))));
};
const TaskBasedProperty = (props) => React.createElement(react_redux_1.Provider, { store: props.store },
    React.createElement(App, Object.assign({}, props)));
exports.TaskBasedProperty = TaskBasedProperty;
//# sourceMappingURL=index.js.map